export default __webpack_public_path__ + "static/emailing-cs-8c5ca781811e8873c059db735fc4b7ba.png";